import { createSvgIcon } from "@mui/material";

const UnpinIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_10627_72996"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_10627_72996)">
      <path
        d="M11.9167 9.5625L6.04168 3.6875C5.97223 3.61806 5.92015 3.54167 5.88543 3.45833C5.8507 3.375 5.83334 3.29167 5.83334 3.20833C5.83334 3.02778 5.89584 2.86458 6.02084 2.71875C6.14584 2.57292 6.31251 2.5 6.52084 2.5H13.3333C13.5695 2.5 13.7674 2.57986 13.9271 2.73958C14.0868 2.89931 14.1667 3.09722 14.1667 3.33333C14.1667 3.55556 14.066 3.71181 13.8646 3.80208C13.6632 3.89236 13.4861 4.01389 13.3333 4.16667V8.95833C13.3333 9.33333 13.1632 9.59375 12.8229 9.73958C12.4826 9.88542 12.1806 9.82639 11.9167 9.5625ZM9.16668 18.3333V13.3333H6.16668C5.81945 13.3333 5.54168 13.2118 5.33334 12.9688C5.12501 12.7257 5.02084 12.4514 5.02084 12.1458C5.02084 11.9931 5.05209 11.8403 5.11459 11.6875C5.17709 11.5347 5.27779 11.3889 5.41668 11.25L6.66668 10V9.04167L1.75001 4.08333C1.59723 3.93056 1.51737 3.73958 1.51043 3.51042C1.50348 3.28125 1.58334 3.08333 1.75001 2.91667C1.90279 2.76389 2.09723 2.6875 2.33334 2.6875C2.56945 2.6875 2.7639 2.76389 2.91668 2.91667L17.0625 17.0625C17.2292 17.2292 17.309 17.4271 17.3021 17.6562C17.2951 17.8854 17.2083 18.0833 17.0417 18.25C16.875 18.4028 16.6806 18.4826 16.4583 18.4896C16.2361 18.4965 16.0417 18.4167 15.875 18.25L10.9583 13.3333H10.8333V18.3333C10.8333 18.5694 10.7535 18.7674 10.5938 18.9271C10.434 19.0868 10.2361 19.1667 10 19.1667C9.7639 19.1667 9.56598 19.0868 9.40626 18.9271C9.24654 18.7674 9.16668 18.5694 9.16668 18.3333Z"
        fill="#00A866"
      />
    </g>
  </svg>,
  "UnpinIcon"
);

export default UnpinIcon;
